import { useTranslation } from 'react-i18next';

import { Box, Form, FormGenerator } from '@/shared/ui';
import { FormFieldValues } from '@/shared/ui/FormGenerator';
import { Logo } from '@/shared/ui/Logo';
import { RouterLink } from '@/shared/ui/RouterLink';
import { CustomTypography } from '@/shared/ui/Typography';
import { getRoutePath } from '@/shared/utils/routes';

import { createLoginSchema } from '../model/schemas';
import { useSignIn } from '../model/useSignIn';

import { StyledBox } from './styles';

export const LoginForm = () => {
  const { t } = useTranslation(['common']);

  const mutation = useSignIn();

  const formScheme = [
    {
      name: 'email',
      label: t('common:inputs.email'),
      type: FormFieldValues.Email,
    },
    {
      name: 'password',
      label: t('common:inputs.password'),
      type: FormFieldValues.Password,
      inputProps: {
        placeholder: t('common:inputs.placeholders.password'),
      },
    },
  ];

  return (
    <StyledBox>
      <Logo />
      <CustomTypography variant="h5" sx={{ mb: 3, mt: 2, fontWeight: 600 }}>
        {t('auth:login.title')}
      </CustomTypography>
      <Form
        schema={createLoginSchema(t)}
        defaultValues={{ email: '', password: '' }}
        mode="onTouched"
        submitBtnText={t('common:buttons.login')}
        mutation={mutation}
        submitBtnProps={{
          fullWidth: false,
          sx: { width: '180px', margin: '0 auto' },
        }}
      >
        <FormGenerator formScheme={formScheme} />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="end"
          width="100%"
          marginTop="12px"
          marginBottom="32px"
        >
          <RouterLink
            to={getRoutePath('AUTH', 'FORGOT_PASSWORD')}
            underline="hover"
            variant="body2"
          >
            {t('auth:login.forgotPassword')}
          </RouterLink>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          // marginBottom="20px"
        >
          <CustomTypography
            variant="body1"
            sx={{
              color: (theme) => theme.palette.custom.black[30],
              marginBottom: '32px',
            }}
          >
            {t('auth:login.noAccount')}{' '}
            <RouterLink
              to={getRoutePath('AUTH', 'REGISTER')}
              underline="hover"
              variant="body2"
            >
              {t('auth:login.registration')}
            </RouterLink>
          </CustomTypography>
        </Box>
      </Form>
    </StyledBox>
  );
};
